var _defs, _g, _polygon, _rect, _path, _path2, _polygon2, _polygon3, _path3, _polygon4, _polygon5, _g2, _polygon6, _rect2, _path4, _path5, _polygon7, _polygon8, _g3, _polygon9, _polygon10, _polygon11, _g4, _rect3, _polygon12, _polygon13, _polygon14, _polygon15, _g5, _polygon16, _path6, _path7, _polygon17, _polygon18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmsLogoMultilineRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.46 128.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#929292;}.cls-4{fill:#646363;}.cls-5{fill:#24bbe7;}.cls-6{fill:#59bba8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 325.46,
    height: 128.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.9,22.16c0-6.31-3.39-8.95-10.4-8.95H25.25V41.8h4.44V17H36.5c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.46,5.49-5.77,5.49H32.31l-1.13,3.79H37.1L42.17,41.8h4.9L41.5,30.45c3.66-1.32,5.4-3.92,5.4-8.29"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.35 17 106.37 17 106.37 41.8 110.86 41.8 110.86 17 118.8 17 118.8 13.21 98.35 13.21 98.35 17"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.46,
    y: 13.21,
    width: 4.44,
    height: 28.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.78,17V13.21H132.86V17h16.47L131.18,37.85V41.8h2.06ZM155,41.8V38H140.08l-3.3,3.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86,17H88.4l4,14.56H81.93ZM74.56,41.83H79l2-6.43H93.34l2.07,6.39H99.9L91.83,13.21H82.71Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "72.52 38.01 57.26 38.01 57.26 17 71.29 17 71.29 13.21 52.77 13.21 52.77 41.8 72.52 41.8 72.52 38.01"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "178.42 38.01 163.16 38.01 163.16 17 177.19 17 177.19 13.21 158.67 13.21 158.67 41.8 178.42 41.8 178.42 38.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,41.8H4.45V13.21H0ZM15.35,13.21,5.9,27.09,16,41.8h5.19L10.87,27.09l9.51-13.88Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.85 25.19 58.77 28.99 68.14 28.99 69.25 25.19 59.85 25.19"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.76 25.19 164.67 28.99 174.04 28.99 175.16 25.19 165.76 25.19"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257,65.22c0-6.31-3.39-8.95-10.4-8.95H235.38V84.86h4.45V60.06h6.81c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.47,5.48-5.78,5.48h-4.23l-1.13,3.8h5.91l5.07,10.28h4.91l-5.58-11.35c3.67-1.32,5.41-3.92,5.41-8.29"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "184.92 60.06 192.94 60.06 192.94 84.86 197.44 84.86 197.44 60.06 205.37 60.06 205.37 56.27 184.92 56.27 184.92 60.06"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 262.91,
    y: 56.27,
    width: 4.45,
    height: 28.59
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.33,60.06h2.36l4,14.56H145.23ZM137.85,84.89h4.44l2-6.44h12.38l2.06,6.4h4.49l-8.06-28.58H146Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.33,60.05h2.36l4,14.55H40.23ZM32.85,84.87h4.44l2-6.43H51.64l2.06,6.39h4.49L50.13,56.25H41Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "125.54 60.06 139.56 60.06 139.56 56.27 121.05 56.27 121.05 84.86 125.54 84.86 125.54 60.06"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "128.13 68.25 127.05 72.05 136.42 72.05 137.53 68.25 128.13 68.25"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.86,74v7a27.09,27.09,0,0,1-4.56.38c-5.85,0-7.06-2.93-7.06-10.7,0-8.07,1.46-10.66,7.19-10.66a82.51,82.51,0,0,1,8.86.67l.17-3.68a56.42,56.42,0,0,0-9.74-1.13c-8.53,0-11.29,4.76-11.29,14.8,0,9.49,2.34,14.75,11.46,14.75a75,75,0,0,0,9.57-1V69.89h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.47,56c-1.89-.07-4.45-.15-6.14-.15-8.57,0-10.74,4.41-10.74,14.6,0,9.65,2,14.55,10.74,14.55,1.59,0,5.23,0,7.64-.08l-1.5-4h-5.38c-5.65,0-6.69-2.72-6.69-10.47,0-8,1.29-10.52,6.56-10.52h5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.54,75.75V56.27H93.86V75.66c0,6.9,3.67,9.7,10.49,9.7s10.57-2.8,10.57-9.7V56.27h-4.68V75.75c0,3.84-2,5.55-5.89,5.55s-5.81-1.67-5.81-5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.73,75.75V56.27h-4.68V75.66c0,6.9,3.68,9.7,10.49,9.7s10.58-2.8,10.58-9.7V56.27h-4.69V75.75c0,3.84-2,5.55-5.89,5.55s-5.81-1.67-5.81-5.55"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "62.58 84.89 67.22 84.89 67.22 60.31 67.8 60.31 79.13 84.89 87.07 84.89 87.07 56.25 82.43 56.25 82.43 80.79 81.8 80.79 70.68 56.25 62.58 56.25 62.58 84.89"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "274.21 84.86 278.85 84.86 278.85 60.28 279.44 60.28 290.76 84.86 298.7 84.86 298.7 56.23 294.06 56.23 294.06 80.76 293.44 80.76 282.32 56.23 274.21 56.23 274.21 84.86"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.86 56.25 14.46 73.34 8.07 56.25 0 56.25 0 84.89 4.64 84.89 4.64 61.39 5.27 61.39 12.04 78.44 16.89 78.44 23.66 61.39 24.29 61.39 24.29 84.89 28.97 84.89 28.97 56.25 20.86 56.25"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.49,108.33c0-6.31-3.4-9-10.41-9H48.83V128h4.45V103.18h6.8c3.94,0,5.82,1.69,5.82,5.24,0,3.3-1.46,5.48-5.77,5.48H55.9l-1.14,3.8h5.92L65.75,128h4.9l-5.57-11.35c3.66-1.32,5.41-3.91,5.41-8.29"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.27,
    y: 99.39,
    width: 4.44,
    height: 28.59
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.45 99.38 24.45 127.97 44.2 127.97 44.2 124.18 28.94 124.18 28.94 103.18 42.97 103.18 42.97 99.38 24.45 99.38"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "133.16 99.38 133.16 127.97 152.91 127.97 152.91 124.18 137.65 124.18 137.65 103.18 151.68 103.18 151.68 99.38 133.16 99.38"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "140.25 111.37 139.16 115.16 148.53 115.16 149.65 111.37 140.25 111.37"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.54 111.37 30.45 115.16 39.83 115.16 40.94 111.37 31.54 111.37"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.59,100a63.51,63.51,0,0,0-9.07-1C3.8,99,0,101.33,0,107.09c0,5,2.67,6.85,8.86,8.44,4.38,1,5.68,1.88,5.68,4.3,0,3-1.63,4.6-5.18,4.6-3,0-8.61-.76-8.61-.76l-.46,3.72a60.82,60.82,0,0,0,9.36,1.13c5.64,0,9.56-2.72,9.56-9,0-4.89-2.17-6.48-8.18-8.15-4.89-1.33-6.39-2-6.39-4.63,0-2.47,1.79-3.72,5.3-3.72,2.42,0,8.27.67,8.27.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.14,100a63.5,63.5,0,0,0-9.06-1c-5.72,0-9.53,2.38-9.53,8.14,0,5,2.68,6.85,8.86,8.44,4.39,1,5.68,1.88,5.68,4.3,0,3-1.63,4.6-5.18,4.6-3,0-8.6-.76-8.6-.76l-.46,3.72a60.81,60.81,0,0,0,9.35,1.13c5.64,0,9.57-2.72,9.57-9,0-4.89-2.17-6.48-8.19-8.15-4.89-1.33-6.39-2-6.39-4.63,0-2.47,1.8-3.72,5.31-3.72,2.42,0,8.27.67,8.27.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.25,99.14c-1.88-.08-4.44-.16-6.13-.16-8.57,0-10.74,4.42-10.74,14.6,0,9.65,2,14.56,10.74,14.56,1.58,0,5.23,0,7.64-.09l-1.51-4h-5.38c-5.64,0-6.68-2.72-6.68-10.48,0-8,1.29-10.51,6.56-10.51h5.5Z"
  }))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.75 99.38 86.03 124.04 83.93 124.04 78.22 99.38 73.35 99.38 80.41 128.15 89.56 128.15 96.62 99.38 91.75 99.38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.59,30.5l1.61-1.27-1.61-.91V30.5ZM263.42,0,245.2,14.29l11,6.28,7.22-5.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.83,25.28l1.6.92V24ZM265.6,0V14.88L272.88,19l10.95-8.69Z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "263.42 41.74 243.59 30.5 243.59 15.55 263.42 26.87 263.42 41.74"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "285.43 11.25 285.43 26.2 265.6 41.83 265.6 26.98 285.43 11.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmsLogoMultilineRight);
export default __webpack_public_path__ + "static/media/kms_logo_multiline_right.aa7f5f02584092079b1dd096d68c3b8e.svg";
export { ForwardRef as ReactComponent };